import { CSVUploadSteps } from '../../components/orders/UploadStops/types/CSVTypes';
import app from '../../store/mst';
import AnalyticsEvents from '../analyticsEvents';
import { AnalyticsEventsProps } from '../analyticsEventsProps';

export enum UPLOAD_EVENT_ACTIONS {
  UPLOAD_ON_SUCCESS = 'onSuccess',
  UPLOAD_ON_ERROR = 'onError',
  UI_SHOW_IMPORT_DIALOG = 'setShowImportDialog',
}

export function trackUploadOnSuccess() {
  const { upload, account } = app;

  // Validation results are folded into this single event so a funnel never has to order two
  // same-timestamp events (ROUT-1976). Counts reflect the auto-matched headers at parse time.
  account.trackUserForAnalytics(AnalyticsEvents.ORDER_FILE_UPLOADED, {
    fileType: upload.rawSheetData?.extension || 'unknown',
    numRowsWithErrors: upload.totalRowsWithErrors,
    numAddressErrors: upload.addressErrorCount,
    numTimeWindowErrors: upload.timeWindowErrorCount,
    numDurationErrors: upload.durationErrorCount,
    numPhoneNumberErrors: upload.phoneNumberErrorCount,
    numDeliveryDateErrors: upload.deliveryDateErrorCount,
    totalRowCount: upload.totalRowCount,
  });
}

export function trackUploadOnError() {
  const { upload, account } = app;

  account.trackUserForAnalytics(AnalyticsEvents.ORDER_FILE_UPLOAD_FAILED, {
    fileType: upload.rawSheetData?.extension || 'unknown',
  });
}

// Maps an upload dialog step to its human-readable modal view name, so MODAL_VIEWED and
// ORDER_IMPORT_CANCELLED report the same vocabulary (e.g. 'Error Fixing View') instead of raw steps.
export function getModalViewName(step: CSVUploadSteps): string {
  if (step === CSVUploadSteps.MAP) {
    return AnalyticsEventsProps.Order.ModalViewNames.DATA_MAPPING;
  }
  if (step === CSVUploadSteps.CONFIRM) {
    return AnalyticsEventsProps.Order.ModalViewNames.ERROR_FIXING;
  }
  return '';
}

export function trackUIShowImportDialog() {
  const { ui, account } = app;

  if (ui.showImportDialog.visible) {
    const viewName = getModalViewName(ui.showImportDialog.step);
    if (viewName) {
      account.trackUserForAnalytics(AnalyticsEvents.MODAL_VIEWED, {
        modalName: AnalyticsEventsProps.Order.ModalNames.ORDER_UPLOAD,
        viewName,
      });
    }
  }
}

export const uploadTrackers = {
  [UPLOAD_EVENT_ACTIONS.UPLOAD_ON_SUCCESS]: trackUploadOnSuccess,
  [UPLOAD_EVENT_ACTIONS.UPLOAD_ON_ERROR]: trackUploadOnError,
  [UPLOAD_EVENT_ACTIONS.UI_SHOW_IMPORT_DIALOG]: trackUIShowImportDialog,
};
